export const getLineChart = (data, series_data) => {
  const seriesData = [];
  series_data.forEach(series_item => {
    const temp_data = {
      name: series_item.label,
      type: 'line',
      data: data.map(function(item) {
        return item.values[series_item.value];
      }),
    };
    seriesData.push(temp_data);
  });

  return {
    tooltip: {
      trigger: 'axis',
    },
    grid: {
      left: '5%',
      right: '5%',
      bottom: '15%',
    },
    xAxis: {
      data: data.map(function(item) {
        return item.date;
      }),
    },
    yAxis: {},
    legend: {
      data: series_data.map(item => item.label),
    },
    dataZoom: [
      {
        type: 'inside',
      },
    ],
    series: seriesData,
  };
};
